export default "__VITE_ASSET__BUIaGdRI__"